/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourResetModelInput = {|
  modelId: string,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderPageResetModelMutationVariables = {|
  input: PGATourResetModelInput
|};
export type PGAModelBuilderPageResetModelMutationResponse = {|
  +pgaTourResetModel: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderPageResetModelMutation = {|
  variables: PGAModelBuilderPageResetModelMutationVariables,
  response: PGAModelBuilderPageResetModelMutationResponse,
|};
*/


/*
mutation PGAModelBuilderPageResetModelMutation(
  $input: PGATourResetModelInput!
) {
  pgaTourResetModel(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourResetModelPayload",
    "kind": "LinkedField",
    "name": "pgaTourResetModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderPageResetModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderPageResetModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f604dbfaee10178be244d0b6331d11b9",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderPageResetModelMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderPageResetModelMutation(\n  $input: PGATourResetModelInput!\n) {\n  pgaTourResetModel(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f5e19cb15bb88eb32d0ab90639a9a94f';

module.exports = node;
